import React from 'react'
import { Video, Image, File } from 'react-feather'
import { FileIconProps } from './types'

export function FileIcon({ mimeType }: FileIconProps): JSX.Element {
  if (typeof mimeType !== 'string') return <File width={16} height={16} />

  if (mimeType.startsWith('image/')) {
    return <Image width={16} height={16} />
  }

  if (mimeType.startsWith('video/')) {
    return <Video width={16} height={16} />
  }

  return <File size={30} width={16} height={16} />
}
